/**
 * 管理后台 API 根地址：统一读取 .env.development / .env.production 中的 VUE_APP_BASE_URL
 */
import { getRequestAuth } from '@/utils/authSession'

export function normalizeApiBaseUrl(url) {
  if (url == null || url === '') {
    return ''
  }
  const trimmed = String(url).trim()
  if (!trimmed) {
    return ''
  }
  return trimmed.endsWith('/') ? trimmed : trimmed + '/'
}

/** 接口根地址，末尾带 / */
export function getApiBaseUrl() {
  return normalizeApiBaseUrl(process.env.VUE_APP_BASE_URL)
}

/** 文件上传地址 */
export function getUploadUrl() {
  const base = getApiBaseUrl()
  return base ? base + 'file/file' : ''
}

/**
 * 拼接业务接口完整 URL（path 不含开头 /，如 Excel/insertAccountExcel）
 */
export function buildApiUrl(path) {
  const base = getApiBaseUrl()
  if (!base) {
    console.warn('[apiBase] 未配置 VUE_APP_BASE_URL，请检查 .env.development / .env.production')
    return ''
  }
  const segment = path.startsWith('/') ? path.slice(1) : path
  return base + segment
}

/**
 * 带登录态导出 Excel（多租户需 X-Tenant-Id）
 * @returns {Promise<{ ok: boolean, msg: string }>}
 */
export async function exportExcel(path, params, filename) {
  const { downloadExcel } = await import('@/utils/utils')
  const auth = getRequestAuth()
  const token = auth?.token
  const tenantId = auth?.tenantId
  if (!token) {
    return { ok: false, msg: '请先登录后再导出' }
  }
  const url = buildApiUrl(path)
  if (!url) {
    return { ok: false, msg: '未配置 API 地址' }
  }
  const ok = await downloadExcel(url, token, params, filename, { tenantId })
  return { ok, msg: ok ? '' : '导出失败，请检查登录状态或时间范围后重试' }
}
